export default "__VITE_ASSET__f38c2d94__"